export default {
    getGardenByName: state => (gardenName) => state.gardens.find((garden) => garden.name == gardenName),
    getGardenPlants: state => (gardenId) => state.gardens.find((garden) => garden.id == gardenId).plants,

    getVGardenSpecyNumber: state => (vgardenId) => {
        const vgarden_plants = state.vgardens.find((vgarden) => vgarden.id === vgardenId).vgarden_plants
        return [...new Set(vgarden_plants.map(vgarden_plant => vgarden_plant.garden_plant.plant.id))].length;
       },
}
